var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"height":!this.hideLeagend ? '300' : '250',"type":"pie","series":_vm.series,"options":_vm.chartOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }